const {galleryGlobalsStrategy} = require('./gallery/galleryGlobalStrategy');
const {GalleryApp} = require('./gallery/components/GalleryApp/GalleryApp');

const {
  withSentryErrorBoundary,
} = require('@wix/native-components-infra/dist/es/src/HOC/sentryErrorBoundary/sentryErrorBoundary');
const {GALLERY_PAGE_DSN} = require('@wix/wixstores-client-core/dist/es/src/viewer-script/sentryConf');
const {getWrappedComponent} = require('./appConfig');

const App = getWrappedComponent({
  entryName: 'gallery',
  Component: GalleryApp,
  globalPropsStrategy: galleryGlobalsStrategy,
});

module.exports = {
  default: {
    component: withSentryErrorBoundary(App, {
      dsn: GALLERY_PAGE_DSN,
      config: {environment: 'Native Component'},
    }),
  },
};
